<!--
 * @Author       : Lobin
 * @Date         : 2022-06-22 21:48:43
 * @LastEditors  : Lobin
 * @Description  : 
 * @LastEditTime : 2022-06-23 21:28:41
-->
<template>
  <div class="search-list">
    <div class="btns">
         <el-button type="primary" @click="addMenu">添加菜单</el-button>
    </div>
    <div class="search-list-data" v-loading="loading">
        <el-table :data="tableData" stripe style="width: 100%" size="medium" border height="500">
            <el-table-column type="index" label="#" width="50">
            </el-table-column>
            <el-table-column prop="name" label="名称" width="180">
            </el-table-column>
            <el-table-column prop="alias" label="别称"> </el-table-column>
            <el-table-column prop="routerPath" label="路由"> </el-table-column>
            <el-table-column prop="ctime" label="创建时间"> </el-table-column>
            <el-table-column
            fixed="right"
            label="操作"
            width="100">
            <template slot-scope="scope">
                <el-button type="text" size="small" @click="editHandler(scope.row)">编辑</el-button>
                <el-button @click="deleteHandler(scope.row._id)" type="text" size="small">删除</el-button>
            </template>
            </el-table-column>
        </el-table>
    </div>
    <el-dialog
        :title="dialogType === 'add' ? '添加菜单' : '编辑菜单'"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="60px" class="demo-ruleForm">
            <el-form-item label="名称" prop="name">
                <el-input v-model="ruleForm.name" placeholder="输入名称"></el-input>
            </el-form-item>
            <el-form-item label="路由" prop="routerPath">
                <el-input v-model="ruleForm.routerPath" placeholder="输入路由"></el-input>
            </el-form-item>
            <el-form-item label="别称" prop="alias">
                <el-input v-model="ruleForm.alias" placeholder="输入别称"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm('ruleForm')" :loading="submitting">立即创建</el-button>
                <el-button @click="cancelHandler">取消</el-button>
            </el-form-item>
            </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      dialogVisible: false,
      tableData: [],
      dialogType: 'add',
      ruleForm: {
        name: '',
        alias: '',
        routerPath: '',
      },
      rules: {
        
      },
      loading: false,
      submitting: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    ...mapActions({
      getMenuList: 'getMenuList',
      createMenu: 'createMenu',
      modifyMenu: 'modifyMenu',
      deleteMenu: 'deleteMenu',
    }),
    async getList() {
      this.loading = true;
      const data = await this.getMenuList(this.formInline);
      this.tableData = data;
      this.loading = false;
    },
    onSubmit() {
      this.getList();
    },
    addMenu() {
      this.dialogVisible = true;
    },
    editHandler(data) {
      this.dialogType = 'modify';
      this.ruleForm = data;
      this.dialogVisible = true;
    },
    async deleteHandler(id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        await this.deleteMenu(id);
        this.$message({
          type: 'success',
          message: '删除成功!',
        });
        this.getList();
      });
    },
    async submitForm() {
      this.submitting = true;
      if (this.dialogType === 'add') {
        await this.createMenu(this.ruleForm);
      } else {
        await this.modifyMenu(this.ruleForm);
      }
      this.$message.success('提交成功');
      this.submitting = false;
      this.dialogVisible = false;
      this.getList();
    },
    handleClose() {
      this.dialogVisible = false;
    },
    cancelHandler() {
      this.handleClose();
    },
  },
};
</script>
<style lang="less" scoped>
.btns {
    margin-bottom: 10px;
}
</style>
